import { observer } from 'mobx-react-lite';
import { company } from '~/company/Company';
import { ProductImageSlider } from '~/components/ProductImageSlider';
import { useGlobal } from '~/hooks/useGlobal';
import { MiscButtons } from '~/pages/Product/Citydrinks/ProductV3/components/MiscButtons';

import type { ProductImageGalleryProps } from './interfaces';
import styles from './ProductImageGallery.module.scss';

const ProductImageGallery = ({
  isBundle,
  bundleImages,
  currentItem,
  product,
  isLoading,
  handleFavorite,
}: ProductImageGalleryProps) => {
  const { isMobile } = useGlobal();

  if (isLoading) {
    return (
      <ProductImageSlider
        isLoading
        thumbsPlacement={
          company.useVerticalProductImageSlider ? 'left' : 'bottom'
        }
        className={styles.root}
      />
    );
  }

  if (
    (isBundle && !bundleImages?.length) ||
    !currentItem?.images.length ||
    !product.selectedOffer
  ) {
    return null;
  }

  const images = (isBundle ? bundleImages : product.selectedOffer.images) ?? [];

  return (
    <ProductImageSlider
      productTitle={product.data?.name}
      images={images}
      thumbsPlacement={
        company.useVerticalProductImageSlider ? 'left' : 'bottom'
      }
      size={
        isMobile
          ? {
              width: company.match({
                mcosmetic: 600,
                default: 233,
              }),
            }
          : {
              width: company.match({
                mcosmetic: 618,
                default: 738,
              }),
            }
      }
      badgesContent={
        isMobile ? (
          <MiscButtons
            product={product}
            handleFavorite={handleFavorite}
            size="M"
            className={styles.badgesContainer}
            isVertical={company.is('mcosmetic')}
          />
        ) : undefined
      }
      isZoomable={company.showProductImageZoom}
    />
  );
};

export default observer(ProductImageGallery);
